import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.NetSuiteRequestCard.NetSuiteMatchingInfo.BillFooter', {
    date: 'Date:',
    amount: 'Amount:',
});
